import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    root: {
        padding: 16,
        marginTop: 48,
        background: '#F8F8F8',
        borderRadius: 16,
        maxWidth: 250
    },
    title: {
        color: '#8E8E8E',
        fontSize: 12,
        marginBottom: 24,
        wordWrap: 'break-word'
    },
    tags: {
        display: 'flex',
        flexWrap: 'wrap',
        columnGap: 4,
        rowGap: 4
    },
    tag: {
        fontSize: 14,
        color: '#5F5F5F',
        padding: '8px 12px',
        textDecoration: 'none',
        borderRadius: 100,
        border: '1px solid #ECECEC',
        textTransform: 'capitalize'
    },
    tagValue: {
        marginLeft: 4,
        color: '#8E8E8E'
    }
});
